import styled from 'styled-components';

export const StyledWrapper = styled.div`
  form {
    max-width: 900px;
  }
`;

export const CancelButtonWrapper = styled.div`
  padding: 30px 10px 0 0;
`;

export const FooterWrapper = styled.div`
  display: flex;
  width: 100%;
`;

export const StyledBackButton = styled.button`
  font-size: 14px;
  height: 32px;
  padding: 4px 15px;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 6px;

  &:hover {
    cursor: pointer;
    color: #0046ff;
    border: 1px solid #0046ff;
  }
`;

export const StyledInlineElements = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
  align-items: center;
  justify-content: flex-start;

  .ant-form-item {
    margin: 0;
    padding: 0;
    width: 100%;
  }
`;

export const StyledAuthFields = styled.div`
  width: 100%;
  padding-left: 150px;

  .ant-radio-group {
    width: 100%;
  }

  .auth-token-form-item,
  .auth-checkbox-form-item {
    .ant-form-item-row .ant-form-item-control {
      max-width: 91.7% !important;
    }
  }
`;
